<template>
  <BaseDialog :is-open="isRevealed" @close="cancel">
    <div class="-mx-4 max-w-lg text-center sm:text-left">
      <HeadlessDialogTitle
        v-if="title"
        as="h3"
        class="p-4 text-lg font-medium text-gray-900"
      >
        {{ title }}
      </HeadlessDialogTitle>

      <div
        v-if="$slots.default || description"
        class="border-y border-background-fg/10 bg-background-fg/5 p-4 leading-snug text-background-fg/87"
      >
        <template v-if="$slots.default">
          <slot></slot>
        </template>
        <p v-else>
          {{ description }}
        </p>
      </div>
    </div>

    <div class="p-4 sm:flex sm:flex-row-reverse">
      <button
        type="button"
        class="inline-flex w-full justify-center rounded-md px-2 py-1 text-base text-background shadow-sm sm:ml-3"
        :class="isPositive ? 'bg-primary' : 'bg-error'"
        @click="confirm"
      >
        {{ confirmLabel }}
      </button>
      <button
        type="button"
        class="mt-3 inline-flex w-full justify-center rounded-md border border-background-fg/20 bg-background px-2 py-1 text-base text-background-fg/87 shadow-sm sm:mt-0"
        @click="cancel"
      >
        {{ cancelLabel }}
      </button>
    </div>
  </BaseDialog>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    title?: string
    description?: string
    confirmLabel?: string
    cancelLabel?: string
    isPositive?: boolean
  }>(),
  {
    title: undefined,
    description: undefined,
    confirmLabel: "Yes",
    cancelLabel: "No",
  }
)
const { reveal, isRevealed, confirm, cancel } =
  useConfirmDialog()

defineExpose({
  reveal,
})
</script>
